<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <h2 style="float: left; margin-left: 15px">Device</h2>
    </el-row>
    <br />
    <el-card>
      <el-row>
        <el-form
          :inline="true"
          :model="query"
          :label-position="'top'"
          class="demo-form-inline"
        >
          <el-col>
            <el-form-item label="Type">
              <el-select
                clearable
                filterable
                autocomplete
                multiple
                allow-create
                default-first-option
                value-key="item"
                v-model="query.type"
                placeholder="Select"
              >
                <el-option
                  v-for="deviceType in deviceTypes"
                  :key="deviceType.type"
                  :label="deviceType.type"
                  :value="deviceType.type"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="macAddress">
              <the-mask
                class="el-input__inner"
                v-model="query.macAddress"
                :masked="true"
                mask="FF:FF:FF:FF:FF:FF"
                @input="sanitize($event)"
                @keyup.enter.native="load"
                :tokens="hexTokens"
              />
            </el-form-item>
            <el-form-item label="Customer" prop="customer">
              <el-select
                v-model="query.customer"
                filterable
                placeholder="Select"
                clearable
              >
                <el-option
                  v-for="item in customerSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Version">
              <el-input
                @keyup.enter.native="load"
                placeholder="Please input"
                v-model="query.version"
              ></el-input>
            </el-form-item>
              <el-form-item label="Connection">
              <el-select
                v-model="query.connectionStatus"
                placeholder="Select"
                clearable
              >
                <el-option
                  v-for="item in connectionStatusSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
        <el-col>
          <el-button
            type="primary"
            @click="
              query.page = 1;
              load();
            "
            >Filter</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
        <el-col>
          <el-table
            v-loading="loading"
            :data="searchResult.devices"
            class="border"
          >
            <el-table-column type="index" width="50">
            <template slot-scope="scope">
            {{(scope.$index+1)+query.pageSize*(query.page-1)}}
            </template>

            </el-table-column>
            <el-table-column
              prop="type"
              label="Type"
              sortable
              column-key="type"
            />
            <el-table-column prop="availableGateways"  label="availableGateways">
              <template slot-scope="scope">
              <el-popover placement="left-end" width="500" trigger="hover">
                  <p style="white-space: pre-wrap">{{ avaliableGatewaysList(scope.row.availableGateways) }}</p>
                  <i
                    class="color-circle"
                    v-bind:style="{
                      'background-color': statusColor(
                        scope.row.availableGateways
                      ),
                    }"
                    slot="reference"
                  ></i>
                </el-popover>
                </template>
            </el-table-column>
            <el-table-column sortable prop="macAddress" label="macAddress" />
            <el-table-column
              prop="customer"
              label="Customer"
              column-key="customer"
              sortable
            >
            <template slot-scope="scope">
            <span v-if="scope.row.customer">
            {{scope.row.customer.name}}
            </span>

            </template>
            </el-table-column>
            <el-table-column sortable prop="version" label="Version" />
            <el-table-column
              sortable
              prop="versionRequestedAt"
              label="VersionRequestedAt"
            />
          </el-table>
        </el-col>

        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
      </el-row>
    </el-card>
    <el-dialog width="30%" title="Edit Device" :visible.sync="editShowform">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        v-loading="formLoading"
        label-width="130px"
      >
        <el-form-item label="Mac Address" prop="macAddress">
          <div class="el-input">
            <the-mask
              class="el-input__inner"
              v-model="form.macAddress"
              :masked="true"
              mask="FF:FF:FF:FF:FF:FF"
              @input="sanitize($event)"
              :tokens="hexTokens"
            />
          </div>
        </el-form-item>
        <el-form-item label="Type" prop="type">
          <el-select v-model="form.type" placeholder="Select">
            <el-option
              v-for="typedeviceType in deviceTypes"
              :key="typedeviceType.type"
              :label="typedeviceType.type"
              :value="typedeviceType.type"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Customer" prop="customer">
          <el-select clearable v-model="form.customer" placeholder="Select">
            <el-option
              v-for="item in customerSelect"
              :key="item.value"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="UpdateDevice()">Save</el-button>
          <el-button @click="Cancel()">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog width="30%" title="Create Device" :visible.sync="showForm">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        v-loading="formLoading"
        label-width="130px"
      >
        <el-form-item label="Mac Address" prop="macAddress">
          <div class="el-input">
            <the-mask
              class="el-input__inner"
              v-model="form.macAddress"
              :masked="true"
              mask="FF:FF:FF:FF:FF:FF"
              @input="sanitize($event)"
              :tokens="hexTokens"
            />
          </div>
        </el-form-item>
        <el-form-item label="Type" prop="type">
          <el-select v-model="form.type" placeholder="Select">
            <el-option
              v-for="t in deviceTypes"
              :key="t.type"
              :label="t.type"
              :value="t.type"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Customer" prop="customer">
          <el-select clearable v-model="form.customer" placeholder="Select">
            <el-option
              v-for="item in customerSelect"
              :key="item.value"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="CreateDevice()">Create</el-button>
          <el-button @click="Cancel()">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import { TheMask } from "vue-the-mask";
import dayjs from "dayjs";
export default {
  name: "Device",
  components: { TheMask },
  data() {
    let IsMacAddress = (rule, value, callback) => {
      if (
        !/^[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}:[0-9A-F]{2}$/g.test(
          value
        )
      ) {
        return callback(
          new Error("Please input proper mac address (ex: AB:CD:EF:12:34:56)")
        );
      }
      return callback();
    };
    return {
      hexTokens: {
        F: {
          pattern: /[0-9a-fA-F]/,
          transform: (v) => v.toLocaleUpperCase(),
        },
      },
      query: {
        connectionStatus:"",
        macAddress: "",
        customer: "",
        type: "",
        version: "",
        page: 1,
        pageSize: 10,
      },
      pageSizes: [10, 25, 50, 75],
      types: [
        {
          value: "ANCHOR",
          label: "Anchor",
        },
        {
          value: "INFINITY",
          label: "Infinity",
          disabled: true,
        },
        {
          value: "WIRED",
          label: "Wired",
        },
        {
          value: "THIRD-PARTY",
          label: "Third-party",
        },
      ],
        connectionStatusSelect: [
        {
          value: "all",
          label: `all`,
          key: "all",
        },
        {
          value: "connected",
          label: `connected`,
          key: "connected",
        },
        {
          value: "disconnected",
          label: `disconnected`,
        }],
      editId: "",
      showForm: false,
      editShowform: false,
      formLoading: false,
      form: {
        customer: "",
        macAddress: "",
        type: "",
      },
      rules: {
        name: [
          { required: true, message: "Please input name", trigger: "blur" },
        ],
        macAddress: [
          {
            validator: IsMacAddress,
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getDevices(this.query);
    this.getDeviceTypes();
    this.getCustomers();
  },
  computed: {
    ...mapState("device", ["searchResult", "loading","deviceTypes"]),
    ...mapState("customer", ["customers"]),
    customerSelect() {
      return this.$store.state.customer.customers.map((x) => {
        return {
          value: x._id,
          label: `${x.name}(${x._id})`,
          key: x._id,
        };
      })
    }
  },
  methods: {
  
    avaliableGatewaysList(avaliableGatewaysList){
     return avaliableGatewaysList.map(x=>x._id.gateway+" - "+  dayjs(x.createdAt).format("DD-MM-YYYY HH:mm:ss")).join("\n")
    },
    statusColor(gateways){
     if (!gateways.length) {
        return "#808080";
      } else {
        return "#00FF00";
      }
    },
    dayFormat(createdAt) {
      return dayjs(createdAt).format("DD-MM-YYYY HH:mm:ss");
    },
    load() {
      this.getDevices(this.query);
    },
    sanitize(value) {
      this.form.macAddress = value.trim().toUpperCase();
    },
    ...mapActions("device", [
      "getDeviceTypes",
      "getDevices",
      "createDevice",
      "updateDevice",
      "deleteDevice",
    ]),
    ...mapActions("customer", ["getCustomers"]),
    adviseSystemAdmin() {
      this.$message.info("advise to the system admin");
    },
    CreateDevice() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.formLoading = true;
          this.createDevice({
            customer: this.form.customer,
            macAddress: this.form.macAddress,
            type: this.form.type,
          })
            .then(() => {
              this.formLoading = false;
              this.showForm = false;
            })
            .finally(() => (this.formLoading = false));
        }
      });
    },
    Delete(scope) {
      this.$confirm(
        "This will permanently delete the device. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.deleteDevice(scope.row._id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    UpdateDevice() {
      this.updateDevice({
        _id: this.editId,
        macAddress: this.form.macAddress,
        type: this.form.type,
        customer: this.form.customer,
      })
        .then(() => {
          this.showForm = false;
          this.editShowform = false;
        })
        .finally(() => {
          this.editId = "";
          this.getDevices(this.query);
        });
    },
    Create() {
      this.editId = undefined;
      this.showForm = true;
      this.form = {
        macAddress: "",
        type: "",
        customer: "",
      };
    },
    Cancel() {
      this.editId = "";
      this.form = {
        macAddress: "",
        type: "",
        customer: "",
      };
      this.editShowform = false;
      this.showForm = false;
    },
    Edit(scope) {
      this.form = {
        customer: scope.row.customer,
        macAddress: scope.row.macAddress,
        type: scope.row.type,
      };
      this.editId = scope.row._id;
      this.editShowform = true;
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
abbr {
  max-width: 150px;
  word-break: initial;
}
.color-circle {
  height: 20px;
  width: 20px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>